export default __webpack_public_path__ + "static/assets/med_capsule_V_tran_01_f_mask.f6816fae.png";